<mat-card>
  <h2 translate="preferences/notifications"></h2>
  <mat-card-content>
    <form [formGroup]="form">
      <ng-template #notificationGroup let-label="label" let-groupName="groupName">
        <div class="notification-group" formGroupName="{{ groupName }}">
          <span [translate]="label"></span>
          <div>
            <mat-checkbox formControlName="notif">
              <span translate="preferences/notifications/web"></span>
            </mat-checkbox>
            <mat-checkbox formControlName="mail">
              <span translate="preferences/notifications/email"></span>
            </mat-checkbox>
          </div>
        </div>
      </ng-template>

      <ng-container
        *ngTemplateOutlet="
          notificationGroup;
          context: { label: 'preferences/notifications/help_requests', groupName: 'HELP_REQUEST' }
        "></ng-container>
      <ng-container
        *ngTemplateOutlet="
          notificationGroup;
          context: { label: 'preferences/notifications/help_answers_for_me', groupName: 'HELP_ANSWER_TO_MY_REQUESTS' }
        "></ng-container>
      <ng-container
        *ngTemplateOutlet="
          notificationGroup;
          context: {
            label: 'preferences/notifications/help_answers_for_others',
            groupName: 'HELP_ANSWER_TO_ALL_REQUESTS'
          }
        "></ng-container>
      <ng-container
        *ngTemplateOutlet="
          notificationGroup;
          context: { label: 'preferences/notifications/message_routed_to_my_team', groupName: 'TASK_ROUTED_TO_MY_TEAM' }
        "></ng-container>
    </form>
  </mat-card-content>
</mat-card>
